/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmAddressSummaryInfo } from './EvmAddressSummaryInfo';

export type ZerogStorageSubmissionsInfo = {
    SEQ: string;
    FHA: string;
    FSTAT: ZerogStorageSubmissionsInfo.FSTAT;
    TRXHA: string;
    ADDR: EvmAddressSummaryInfo;
    SI: string;
    BF: string;
    BFVAL: string;
    AG: string;
    UT: number;
};

export namespace ZerogStorageSubmissionsInfo {

    export enum FSTAT {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
        PENDING = 'PENDING',
        FAILED = 'FAILED',
        OUT_COMING = 'OUT_COMING',
        IN_COMING = 'IN_COMING',
        ALL = 'ALL',
    }


}

